import { render } from "./DocumentsEmployee.vue?vue&type=template&id=4ed4977e"
import script from "./DocumentsEmployee.vue?vue&type=script&lang=js"
export * from "./DocumentsEmployee.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__